module.exports = __webpack_public_path__ + "static/media/google-calendar-icon@2x.c2c9a9d1.png";